module.exports = __webpack_public_path__ + "static/fonts/Fact-BoldItalic.68edb30.eot";